import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseAlertComponent from '../BaseAlert.component';
import styled from 'styled-components';
import ButtonComponent from '../../Button.component';
import { useModalManager } from '../../../hooks/ModalManager.hook';
import useAuthHook from '../../../hooks/useAuth.hook';

const StyledUserLogoutAlert = styled.div``;

const UserLogoutAlertComponent = () => {
  const { t } = useTranslation();
  const { closeModal } = useModalManager();
  const { handleLogout } = useAuthHook();

  return (
    <StyledUserLogoutAlert>
      <BaseAlertComponent
        header={t('Log out')}
        footer={
          <React.Fragment>
            <ButtonComponent handleClick={() => closeModal()}>
              {t('Cancel')}
            </ButtonComponent>
            <ButtonComponent
              appearance="primary"
              handleClick={() => handleLogout()}
            >
              {t('Log out')}
            </ButtonComponent>
          </React.Fragment>
        }
      >
        {t('Log out message')}
      </BaseAlertComponent>
    </StyledUserLogoutAlert>
  );
};

export default UserLogoutAlertComponent;
